import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/AlternativeToolsTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/CompanyLogosMarquee.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/FAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/TrustedBy.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/components/Typography.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/components/VideoInput.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/app-dir/link.js");
